import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IUnitTriggerModel } from '@apps-common/types/portal/unit-trigger'

export const QUERY_KEY_GET_UNIT_TRIGGER = (id?: number) => ['getUnitTrigger', id].filter(Boolean)

const getUnitTrigger = async (triggerId: number): Promise<IUnitTriggerModel> =>
  axios.get(`/unittrigger/gettrigger?triggerId=${triggerId}`).then((res) => res.data?.data)

type QueryFnType = typeof getUnitTrigger

type Props = {
  config?: QueryConfig<QueryFnType>
  triggerId: number
}

export const useGetUnitTrigger = ({ config, triggerId }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: QUERY_KEY_GET_UNIT_TRIGGER(triggerId),
    queryFn: () => getUnitTrigger(triggerId)
  })
